module.exports = __webpack_public_path__ + "img/2-consumers-and-stylists-tape.png";